import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface IEvent {
    id?: string
    language?: string
    name?: string
    thumbnail?: string
    new_thumbnail?: string
    url?: string
    start_at?: string
    end_at?: string
    priority?: number
    created_at?: string
    updated_at?: string
    show_on_account_page?: boolean
    background_color?: string[]
}

export const getEventApi = async (
    pageSize: number,
    currentPage: number,
    active: boolean,
): Promise<ApiRes<IEvent[]>> => {
    return await apiGet(API_URL, `admin/events?page_size=${pageSize}&current_page=${currentPage}&active=${active}`)
}
